import { SubmissionError } from "redux-form";

// import Tracking from '../../utils/tracking'

export const submissionErrorHandler = (
  res,
  defaultError = "There were errors submitting the form"
) => {
  let error = res.response.data.error || res.response.data.errors || {};
  let details = { _error: defaultError };

  if (error) {
    if (error.isJoi) {
      error.details.forEach((err) => {
        details[err.path] = err.message;
      });
    }

    if (Array.isArray(error)) {
      error.forEach((err) => {
        if (err.general) {
          details._error = err.general;
        }
        details = { ...details, ...err };
      });
    } else {
      details = { ...details, ...error };
    }
  }

  throw new SubmissionError(details);
};
